/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Tooltip,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { CustomStack } from 'modules/common/components';
import styles from 'modules/dashboard/components/tab-container/inner-filter/inner-filter.module.scss';
/**
 * Percentage window component common for the dashboard component
 * @param {*} percentage - percentage selected state
 * @param {Array} percentageList - Percentages list
 * @param {Function} handlePercentageChange - Function to set percentage value
 * @param {Boolean} isPercentageDisabled - To enable or disable percentage filter
 * @returns
 */
const PercentageWindow = ({
  percentage,
  percentageList,
  handlePercentageChange,
  isPercentageDisabled,
}) => (
  <CustomStack cssClassName={styles.innerFilter}>
    <FormControl>
      <Grid container alignItems="center" className='percentage'>
        <FormLabel>Percentage</FormLabel>
        <Tooltip
          color="primary"
          className={styles.infoIcon}
          title="The 'Percentage' filter will only apply when the filter is in an 'Active' state."
        >
          <InfoIcon />
        </Tooltip>
      </Grid>
      <RadioGroup value={percentage ?? null} onChange={handlePercentageChange}>
        {percentageList?.map((item) => (
          <FormControlLabel
            key={item?.id}
            value={item?.id}
            control={<Radio />}
            label={item?.label}
            sx={{
              my: -1,
            }}
            disabled={isPercentageDisabled}
          />
        ))}
      </RadioGroup>
    </FormControl>
  </CustomStack>
);
//
export default PercentageWindow;
